/* ============================================================
   ALCMY — SBD Cart Drawer behaviour
   ============================================================ */
(function () {
  'use strict';

  var DRAWER_ID = 'CartDrawer';

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $all(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function formatMoney(cents) {
    try {
      if (window.theme && theme.Currency && theme.settings && theme.settings.moneyFormat) {
        return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
      }
    } catch (e) {}
    return '£' + (cents / 100).toFixed(2);
  }

  function getDrawer() { return document.getElementById(DRAWER_ID); }

  /* ---------- Free shipping bar + item count ---------- */
  function renderProgress(totalCents, itemCount) {
    var drawer = getDrawer();
    if (!drawer) return;

    var countEl = $('[data-cd-itemcount]', drawer);
    if (countEl && typeof itemCount === 'number') {
      countEl.textContent = itemCount > 0 ? ('(' + itemCount + (itemCount === 1 ? ' item)' : ' items)')) : '';
    }

    var bar = $('[data-cd-shipbar]', drawer);
    if (!bar) return;
    var threshold = parseInt(drawer.getAttribute('data-free-threshold'), 10);
    if (!threshold || isNaN(threshold)) return;

    var fill = $('[data-cd-shipfill]', bar);
    var msg  = $('[data-cd-shipmsg]', bar);
    var boldPhrase = bar.getAttribute('data-bold-phrase') || '';

    var emphasise = function (text) {
      if (boldPhrase && text.indexOf(boldPhrase) !== -1) {
        return text.replace(boldPhrase, '<strong>' + boldPhrase + '</strong>');
      }
      return text;
    };

    if (totalCents >= threshold) {
      bar.classList.add('is-complete');
      if (fill) fill.style.width = '100%';
      if (msg) msg.innerHTML = emphasise(bar.getAttribute('data-msg-complete') || 'You have unlocked free shipping');
    } else {
      bar.classList.remove('is-complete');
      var pct = Math.max(4, Math.min(100, Math.round((totalCents / threshold) * 100)));
      if (fill) fill.style.width = pct + '%';
      var remaining = formatMoney(threshold - totalCents);
      var tpl = bar.getAttribute('data-msg-remaining') || 'You are [amount] away from free shipping';
      if (msg) msg.innerHTML = emphasise(tpl.replace('[amount]', remaining).replace('{amount}', remaining));
    }
  }

  function hydrateBadges() {
    try { if (window.jdgm && typeof jdgm.batchRenderBadges === 'function') jdgm.batchRenderBadges(); } catch (e) {}
  }

  /* ==========================================================================
     RECOMMENDATIONS ENGINE
     Waterfall:
       1. Curated pairings from product metafield (custom.cart_pairings)
       2. Bestsellers collection fallback
       3. Shopify recommendations API
     ========================================================================== */
  var lastSeed = null;

  function pickSeed(cart) {
    if (!cart || !cart.items || !cart.items.length) return null;
    var hero = cart.items.reduce(function (a, b) {
      return (b.price || 0) > (a.price || 0) ? b : a;
    });
    if (hero && !hero.handle && hero.url) {
      var match = hero.url.match(/\/products\/([^?#/]+)/);
      if (match) hero.handle = match[1];
    }
    return hero;
  }

  /* Apply exclusion rules to cards in mount.
     skipTypeFilter=true for curated and bestsellers paths. */
  function applyFilters(mount, cart, section, skipTypeFilter) {
    var cartIds   = (cart.items || []).map(function (i) { return i.product_id; });
    var cartTypes = (cart.items || []).map(function (i) {
      return (i.product_type || '').toLowerCase().trim();
    }).filter(Boolean);
    var heroGender = section.getAttribute('data-hero-gender') || '';

    $all('[data-cd-xsell-item]', mount).forEach(function (card) {
      var pid    = parseInt(card.getAttribute('data-product-id'), 10);
      var ptype  = (card.getAttribute('data-product-type') || '').toLowerCase().trim();
      var gender = (card.getAttribute('data-gender') || '').toLowerCase().trim();
      var hide   = false;

      if (cartIds.indexOf(pid) !== -1) hide = true;
      if (!hide && !skipTypeFilter && ptype && cartTypes.indexOf(ptype) !== -1) hide = true;
      if (!hide && heroGender && gender && gender !== heroGender) hide = true;

      card.style.display = hide ? 'none' : '';
    });
  }


  /* Top-up helpers -----------------------------------------------------------
     The chain was first-match-wins: if the curated pairings metafield returned
     even one product, capVisible() capped DOWN to the limit but nothing ever
     topped UP. So a product paired with two items always showed two, however
     high "Number of products" was set.

     appendUnique() merges cards from the next source in, skipping any product
     already mounted and anything already in the cart, so pairings stay first and
     the remaining slots are filled by bestsellers and then the recommendations
     API. Order of preference is preserved.
  -------------------------------------------------------------------------- */
  function mountedIds(mount) {
    return $all('[data-cd-xsell-item]', mount).map(function (c) {
      return parseInt(c.getAttribute('data-product-id'), 10);
    });
  }

  function appendUnique(mount, html, selector) {
    var tmp = document.createElement('div');
    tmp.innerHTML = html;
    var src = tmp.querySelector(selector);
    if (!src) return 0;
    var have = mountedIds(mount);
    var added = 0;
    $all('[data-cd-xsell-item]', src).forEach(function (card) {
      var pid = parseInt(card.getAttribute('data-product-id'), 10);
      if (have.indexOf(pid) !== -1) return;
      have.push(pid);
      mount.appendChild(card);
      added++;
    });
    return added;
  }

  /* Fill any remaining slots from the bestsellers collection, then the
     recommendations API. Called only when an earlier source came up short. */
  function topUp(section, mount, cart, limit, seedItem, skipTypeFilter) {
    var bestSection = section.getAttribute('data-cd-bestsellers-section');
    var bestHandle  = section.getAttribute('data-cd-bestsellers-handle');

    function finish() {
      applyFilters(mount, cart, section, skipTypeFilter);
      capVisible(mount, limit);
      showXsell(section, countVisible(mount) > 0);
      hydrateBadges();
    }

    function viaRecos() {
      var intent  = section.getAttribute('data-cd-reco-intent') || 'related';
      var secId   = section.getAttribute('data-cd-reco-section');
      if (!secId || !seedItem || !seedItem.product_id) { finish(); return; }
      fetch('/recommendations/products?section_id=' + encodeURIComponent(secId) +
            '&product_id=' + seedItem.product_id +
            '&limit=' + Math.min(12, limit + 6) +
            '&intent=' + encodeURIComponent(intent), { credentials: 'same-origin' })
        .then(function (r) { return r.text(); })
        .then(function (html) { appendUnique(mount, html, '[data-cd-reco-cards]'); finish(); })
        .catch(finish);
    }

    if (bestSection && bestHandle) {
      fetch('/collections/' + encodeURIComponent(bestHandle) +
            '?section_id=' + encodeURIComponent(bestSection), { credentials: 'same-origin' })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          appendUnique(mount, html, '[data-cd-bestsellers-cards]');
          applyFilters(mount, cart, section, skipTypeFilter);
          if (countVisible(mount) >= limit) { finish(); } else { viaRecos(); }
        })
        .catch(viaRecos);
    } else {
      viaRecos();
    }
  }

  function capVisible(mount, limit) {
    var shown = 0;
    $all('[data-cd-xsell-item]', mount).forEach(function (card) {
      if (card.style.display === 'none') return;
      shown++;
      if (shown > limit) card.style.display = 'none';
    });
  }

  function countVisible(mount) {
    return $all('[data-cd-xsell-item]', mount).filter(function (c) {
      return c.style.display !== 'none';
    }).length;
  }

  /* Show/hide the xsell section — uses style.display so it
     doesn't fight with the hidden attribute or CSS specificity. */
  function showXsell(section, show) {
    section.style.display = show ? '' : 'none';
    if (show) { section.removeAttribute('hidden'); }
  }

  function finishRender(section, mount, cart, limit, skipTypeFilter) {
    applyFilters(mount, cart, section, skipTypeFilter);
    capVisible(mount, limit);
    var ok = countVisible(mount) > 0;
    showXsell(section, ok);
    if (ok) hydrateBadges();
  }

  /* Step 3: Shopify recommendations API */
  function fetchShopifyRecos(section, mount, cart, limit, seedItem) {
    var sectionId  = section.getAttribute('data-cd-reco-section');
    var intent     = section.getAttribute('data-cd-reco-intent') || 'related';
    var fetchLimit = Math.min(12, limit + 6);
    var url = '/recommendations/products?section_id=' + encodeURIComponent(sectionId) +
              '&product_id=' + seedItem.product_id +
              '&limit=' + fetchLimit +
              '&intent=' + encodeURIComponent(intent);

    fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var cards = tmp.querySelector('[data-cd-reco-cards]');
        mount.innerHTML = cards ? cards.innerHTML : '';
        section.setAttribute('data-cd-curated', 'false');
        finishRender(section, mount, cart, limit, false);
      })
      .catch(function () { showXsell(section, false); recoInFlight = false; });
  }

  /* Step 2: Bestsellers collection */
  function fetchFallback(section, mount, cart, limit, seedItem) {
    var bestsellersSection = section.getAttribute('data-cd-bestsellers-section');
    var bestsellersHandle  = section.getAttribute('data-cd-bestsellers-handle');

    if (bestsellersSection && bestsellersHandle) {
      fetch('/collections/' + encodeURIComponent(bestsellersHandle) +
            '?section_id=' + encodeURIComponent(bestsellersSection), {
        credentials: 'same-origin'
      })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var tmp = document.createElement('div');
          tmp.innerHTML = html;
          var cards = tmp.querySelector('[data-cd-bestsellers-cards]');
          console.log('[CD-BEST] handle:', bestsellersHandle, 'cards:', cards ? cards.children.length : 0);
          mount.innerHTML = cards ? cards.innerHTML : '';
          section.setAttribute('data-cd-curated', 'true');
          applyFilters(mount, cart, section, true);
          if (countVisible(mount) > 0) {
            if (countVisible(mount) < limit) {
              topUp(section, mount, cart, limit, seedItem, true);
            } else {
              capVisible(mount, limit);
              showXsell(section, true);
              hydrateBadges();
            }
          } else {
            mount.innerHTML = '';
            fetchShopifyRecos(section, mount, cart, limit, seedItem);
          }
        })
        .catch(function () {
          fetchShopifyRecos(section, mount, cart, limit, seedItem);
        });
    } else {
      fetchShopifyRecos(section, mount, cart, limit, seedItem);
    }
  }

  /* Step 1: Curated pairings from product metafield */
  function fetchPairings(section, mount, cart, limit, seedItem) {
    var pairingsSection = section.getAttribute('data-cd-pairings-section');
    if (!pairingsSection || !seedItem.handle) {
      fetchFallback(section, mount, cart, limit, seedItem);
      return;
    }

    var url = '/products/' + encodeURIComponent(seedItem.handle) +
              '?section_id=' + encodeURIComponent(pairingsSection);

    fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var cards = tmp.querySelector('[data-cd-pairings-cards]');
        console.log('[CD-PAIR] cards:', cards ? cards.children.length : 0);
        mount.innerHTML = cards ? cards.innerHTML : '';

        applyFilters(mount, cart, section, true);
        var surviving = countVisible(mount);
        console.log('[CD-PAIR] surviving:', surviving);

        if (surviving > 0) {
          section.setAttribute('data-cd-curated', 'true');
          if (surviving < limit) {
            /* pairings came up short - fill the remaining slots rather than
               stopping here, which is what limited every paired product to the
               number of pairings set on it */
            topUp(section, mount, cart, limit, seedItem, true);
          } else {
            capVisible(mount, limit);
            showXsell(section, true);
            hydrateBadges();
          }
        } else {
          section.setAttribute('data-cd-curated', 'false');
          mount.innerHTML = '';
          fetchFallback(section, mount, cart, limit, seedItem);
        }
      })
      .catch(function () {
        fetchFallback(section, mount, cart, limit, seedItem);
      });
  }

  /* Fetch hero gender from product.json */
  function fetchHeroGender(seedItem, callback) {
    if (!seedItem.handle) { callback(''); return; }
    fetch('/products/' + encodeURIComponent(seedItem.handle) + '.json', {
      credentials: 'same-origin'
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var tags = ((data.product && data.product.tags) || []).join('|').toLowerCase();
        var hasMale   = tags.indexOf('gender:male') !== -1;
        var hasFemale = tags.indexOf('gender:female') !== -1;
        var gender = '';
        if (hasMale && !hasFemale)      gender = 'male';
        else if (hasFemale && !hasMale) gender = 'female';
        callback(gender);
      })
      .catch(function () { callback(''); });
  }

  function loadRecommendations(cart) {
    var drawer = getDrawer();
    if (!drawer) return;
    var section = $('[data-cd-reco]', drawer);
    if (!section) return;

    var mount    = $('[data-cd-reco-mount]', section);
    var limit    = parseInt(section.getAttribute('data-cd-reco-limit'), 10) || 2;
    var seedItem = pickSeed(cart);

    if (!seedItem) { showXsell(section, false); return; }

    // Same hero — re-run filters on cached cards only if we actually have cards
    if (seedItem.product_id === lastSeed) {
      if (mount.children.length) {
        var isCurated = section.getAttribute('data-cd-curated') === 'true';
        finishRender(section, mount, cart, limit, isCurated);
      }
      // If mount is empty, first fetch is still in flight — do nothing
      return;
    }



    lastSeed = seedItem.product_id;
    section.removeAttribute('data-hero-gender');
    section.removeAttribute('data-cd-curated');

    fetchHeroGender(seedItem, function (gender) {
      if (gender) section.setAttribute('data-hero-gender', gender);
      fetchPairings(section, mount, cart, limit, seedItem);
    });
  }

  function refreshFromCart(cart) {
    if (!cart) return;
    var drawer = getDrawer();
    if (drawer) drawer.setAttribute('data-cart-total', cart.total_price);
    renderProgress(cart.total_price, cart.item_count);
    loadRecommendations(cart);
  }

  function fetchCartAndRefresh() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) { refreshFromCart(cart); return cart; })
      .catch(function () {});
  }

  /* ---------- AJAX remove ---------- */
  function removeItem(key) {
    var drawer = getDrawer();
    if (drawer) drawer.classList.add('cart-is-loading');
    fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.dispatchEvent(new CustomEvent('cart:build'));
        refreshFromCart(cart);
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
      })
      .catch(function () {})
      .then(function () { if (drawer) drawer.classList.remove('cart-is-loading'); });
  }

  /* ---------- Add to cart ---------- */
  function addToCart(variantId) {
    var drawer = getDrawer();
    if (drawer) drawer.classList.add('cart-is-loading');
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        document.dispatchEvent(new CustomEvent('cart:build'));
        return fetchCartAndRefresh();
      })
      .catch(function () {})
      .then(function () { if (drawer) drawer.classList.remove('cart-is-loading'); });
  }

  /* ---------- Variant resolution ---------- */
  function resolveVariant(card) {
    var dataEl = $('[data-cd-variants]', card);
    if (!dataEl) return null;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return null; }
    var selects = $all('[data-cd-opt-index]', card).sort(function (a, b) {
      return parseInt(a.getAttribute('data-cd-opt-index'), 10) - parseInt(b.getAttribute('data-cd-opt-index'), 10);
    });
    var chosen = selects.map(function (s) { return s.value; });
    return variants.find(function (v) {
      return v.options.length === chosen.length && v.options.every(function (o, i) { return o === chosen[i]; });
    }) || null;
  }

  function updateVariantBtn(card) {
    var btn = $('[data-cd-add-variant]', card);
    if (!btn) return;
    var v = resolveVariant(card);
    if (v && v.available) {
      btn.disabled = false;
      btn.setAttribute('data-variant-id', v.id);
    } else {
      btn.disabled = true;
      btn.removeAttribute('data-variant-id');
    }
  }

  /* ---------- Discount toggle ---------- */
  function bindDiscount(drawer) {
    var toggle = $('[data-cd-discount-toggle]', drawer);
    var panel  = $('[data-cd-discount-panel]', drawer);
    if (toggle && panel) {
      toggle.addEventListener('click', function () {
        var open = !panel.hasAttribute('hidden');
        if (open) { panel.setAttribute('hidden', ''); } else { panel.removeAttribute('hidden'); }
        toggle.setAttribute('aria-expanded', String(!open));
        if (!open) { var inp = $('[data-cd-discount-input]', panel); if (inp) inp.focus(); }
      });
    }
    var apply = $('[data-cd-discount-apply]', drawer);
    var input = $('[data-cd-discount-input]', drawer);
    var go = function () {
      var code = (input && input.value || '').trim();
      if (!code) { if (input) input.focus(); return; }
      var redirect = window.location.pathname + window.location.search;
      window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(redirect);
    };
    if (apply) apply.addEventListener('click', go);
    if (input) input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); go(); } });
  }

  /* ---------- Cross-sell delegation ---------- */
  function bindCrossSell(drawer) {
    drawer.addEventListener('click', function (e) {
      var removeBtn = e.target.closest('[data-cd-remove]');
      if (removeBtn) {
        e.preventDefault();
        var key = removeBtn.getAttribute('data-key');
        if (key) removeItem(key);
        return;
      }

      var optionsBtn = e.target.closest('[data-cd-options]');
      if (optionsBtn) {
        var card = optionsBtn.closest('[data-cd-xsell-item]');
        var opts = $('[data-cd-opts]', card);
        if (opts) {
          var open = !opts.hasAttribute('hidden');
          if (open) { opts.setAttribute('hidden', ''); } else { opts.removeAttribute('hidden'); updateVariantBtn(card); }
          optionsBtn.setAttribute('aria-expanded', String(!open));
        }
        return;
      }

      var addVariantBtn = e.target.closest('[data-cd-add-variant]');
      if (addVariantBtn && !addVariantBtn.disabled) {
        var id = addVariantBtn.getAttribute('data-variant-id');
        if (id) addToCart(id);
        return;
      }

      var addBtn = e.target.closest('[data-cd-add]');
      if (addBtn) {
        var vid = addBtn.getAttribute('data-variant-id');
        if (vid) addToCart(vid);
      }
    });

    drawer.addEventListener('change', function (e) {
      if (e.target.closest('[data-cd-opt-index]')) {
        var card = e.target.closest('[data-cd-xsell-item]');
        if (card) updateVariantBtn(card);
      }
    });
  }

  /* ---------- Init ---------- */
  function init() {
    var drawer = getDrawer();
    if (!drawer) return;

    bindDiscount(drawer);
    bindCrossSell(drawer);

    var total = parseInt(drawer.getAttribute('data-cart-total'), 10) || 0;
    var count = parseInt(drawer.getAttribute('data-item-count'), 10) || 0;
    renderProgress(total, count);

    document.addEventListener('cart:updated', function (evt) {
      if (evt.detail && evt.detail.cart) refreshFromCart(evt.detail.cart);
      else fetchCartAndRefresh();
    });

    document.addEventListener('drawerOpen.' + DRAWER_ID, fetchCartAndRefresh);

    if (window.MutationObserver) {
      new MutationObserver(function () {
        var isOpen = drawer.classList.contains('drawer--is-open');
        try { if (window.zE) zE('webWidget', isOpen ? 'hide' : 'show'); } catch (e) {}
      }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
    }

    fetchCartAndRefresh();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();